// [F-MININAV2 T-9] Közös formázók az előnézetekhez (a Projektek / Keresés / jelölt-kártya eddigi
// 3 másolata helyett).
/** Unix másodperc / numerikus string -> "ÉÉÉÉ-HH-NN ÓÓ:PP". Más stringet változatlanul ad vissza. */
export function formatTimestamp(ts) {
    if (ts === undefined || ts === null || ts === '') {
        return '';
    }
    const num = typeof ts === 'number' ? ts : Number(ts);
    if (!isFinite(num) || num <= 0) {
        return String(ts);
    }
    const d = new Date(num * 1000);
    if (isNaN(d.getTime())) {
        return String(ts);
    }
    const pad = (n) => (n < 10 ? '0' + n : String(n));
    return (d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()));
}
/** FontAwesome ikon-osztály: fa* család-prefix nélkül 'fas ' elé kerül. */
export function fullIconClass(icon, fallback) {
    const cls = (icon || fallback).toString().trim();
    return /(^|\s)(fa|fab|fas|far|fal|fad)(\s|$)/.test(cls) ? cls : 'fas ' + cls;
}
